interface KeyboardProps {
  onKeyPress: (key: string) => void;
  letterStates: Record<string, 'correct' | 'present' | 'absent'>;
  darkMode: boolean;
}

export default function Keyboard({ onKeyPress, letterStates, darkMode }: KeyboardProps) {
  const rows = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['ENTER', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'BACKSPACE']
  ];

  const getKeyColor = (key: string) => {
    const state = letterStates[key];
    if (state === 'correct') return 'bg-teal-500 text-white border-teal-500';
    if (state === 'present') return 'bg-amber-500 text-white border-amber-500';
    if (state === 'absent') return darkMode ? 'bg-gray-700 text-gray-400 border-gray-700' : 'bg-gray-400 text-white border-gray-400';
    return darkMode ? 'bg-gray-600 text-white border-gray-600 hover:bg-gray-500' : 'bg-gray-200 text-gray-900 border-gray-300 hover:bg-gray-300';
  };

  const renderKey = (key: string) => {
    const isSpecial = key === 'ENTER' || key === 'BACKSPACE';
    
    return (
      <button
        key={key}
        onClick={() => onKeyPress(key)}
        className={`${
          isSpecial ? 'px-4 text-xs' : 'w-10'
        } h-14 rounded-md font-semibold border-2 transition-all duration-200 active:scale-95 cursor-pointer whitespace-nowrap ${getKeyColor(key)}`}
      >
        {key === 'BACKSPACE' ? (
          <i className="ri-delete-back-2-line text-lg"></i>
        ) : (
          key
        )}
      </button>
    );
  };

  return (
    <div className="flex flex-col gap-2">
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="flex gap-1.5 justify-center">
          {row.map(renderKey)}
        </div>
      ))}
    </div>
  );
}
